import { render, staticRenderFns } from "./EmailContentSettings.vue?vue&type=template&id=6864a345&scoped=true&"
import script from "./EmailContentSettings.vue?vue&type=script&lang=js&"
export * from "./EmailContentSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmailContentSettings.vue?vue&type=style&index=0&id=6864a345&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6864a345",
  null
  
)

export default component.exports